import router from "../router";
import store from "../store";

export default function toLogin(push) {
  store.commit("LOGOUT");
  const { name } = router.currentRoute;
    if (name !== "Login") {
      push
        ? router.push({ path: "/login" })
        : router.replace({ path: "/login" });
    }
}
